import React from "react";
import { Link } from "react-router-dom";
import { css } from "@emotion/react";

type Props = {
    link?: string,
    children: any,
    className?: string,
};

const WizardLink: React.FC<Props> = ({link, children, className = ''}) => {
    if (link) {
        return (
            <Link to={link} css={linkStyle} className={className}>{children}</Link>
        );
    }

    return (
        <>
            {children}
        </>
    )
}

const linkStyle = css`
    width: 100%;
    height: 100%;
    display: inherit;
    text-decoration: none;
`

export default WizardLink;
